import React, { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { useLocation } from "react-router";
import moment from "moment";
import ListaRate from "../Objects/ListaRate";
import { Redirect } from "react-router-dom";
import Repo from "../Utility/Repo";
import logopagopa from "../../Img/pagopa-logo.png";
import PagoPAButton from "../Objects/PagoPAButton";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import useLocalStorage from "../Utility/useLocalStorage";


function DettaglioPagamentiAttesi(props) {
  const [cookies] = useCookies();
  const [apiToken] = useState(cookies.api_token);

  const [dataDownload, setDataDownload] = useState({})
  const [data, setData] = useState({})


  const [responseDovuti, setResponse, removeResponse] =
    useLocalStorage("responsePagamentiAttesi");

  const [responsePagamentiCartella] =
    useLocalStorage("responseCartellaPagamentiAttesi");


  let { search } = useLocation();
  const query = new URLSearchParams(search);
  const paramsId = query.get("id");


  const [pagamento, setPagamento] = useState([]);
  const baseUrl = location.protocol + "//" + location.host;


  const [contribuente, setContribuente, removeContribuente] =
    useLocalStorage("responseContribuente");




  useEffect(() => {

    var getOne = {}
    if (responseDovuti) {

      getOne = responseDovuti.find(obj => {
        return obj.idPagamento === paramsId
      })
    }
    else {
      getOne = responsePagamentiCartella.find(obj => {
        return obj.idPagamento === paramsId
      })


    }




    setPagamento(getOne);

   
    if (contribuente) {
      setDataDownload({
        cfpIva:  contribuente.cfPiva,
        nomeCognomePagatore:contribuente.nome + " " + contribuente.cognome,
        dataScadenza: getOne.dataScadenza,
        identificativoPosizioneDebitoria: getOne.quartoCampo,
        idTipoEntrata: getOne.idTipoEntrata,
        idTipoEntrataVerticale: getOne.idTipoEntrataVerticale,
        causale: getOne.causale,
        importo: getOne.importoDovuto,
      });
      setData({
        cfpIva: contribuente.cfPiva,
        anagraficaPagatore:contribuente.nome + " " + contribuente.cognome,
        importoTotale: getOne.importoDovuto,
        ReturnUrl: baseUrl + "/payment_check",
        idTipoEntrata: getOne.idTipoEntrata,
        idTipoEntrataVerticale: getOne.idTipoEntrataVerticale,
        pagamenti: [
          {
            importo: getOne.importoDovuto,
            causale: getOne.causale,
            quartoCampo: getOne.quartoCampo,
            idTipoEntrata: getOne.idTipoEntrata,
            idTipoEntrataVerticale: getOne.idTipoEntrataVerticale,
          },
        ],
      });
  

    } else {

     
      setDataDownload({
        cfpIva: "RMNPQL76T06F052K",
        nomeCognomePagatore: props.user.FirstName + " " + props.user.LastName,
        dataScadenza: getOne.dataScadenza,
        identificativoPosizioneDebitoria: getOne.quartoCampo,
        idTipoEntrata: getOne.idTipoEntrata,
        idTipoEntrataVerticale: getOne.idTipoEntrataVerticale,
        causale: getOne.causale,
        importo: getOne.importoDovuto,
      });


      setData({
        cfpIva: "RMNPQL76T06F052K",
        anagraficaPagatore:  props.user.FirstName + " " + props.user.LastName,
        importoTotale: getOne.importoDovuto,
        ReturnUrl: baseUrl + "/payment_check",
        idTipoEntrata: getOne.idTipoEntrata,
        idTipoEntrataVerticale: getOne.idTipoEntrataVerticale,
        pagamenti: [
          {
            importo: getOne.importoDovuto,
            causale: getOne.causale,
            quartoCampo: getOne.quartoCampo,
            idTipoEntrata: getOne.idTipoEntrata,
            idTipoEntrataVerticale: getOne.idTipoEntrataVerticale,
          },
        ],
      });
  
    }


 



  }, [props]);


  const downloadFile = () => {


    if (pagamento.idRata) {
      dataDownload["numeroRata"] = pagamento.numeroRata;
    }

    var dataJsonDownload = JSON.stringify(dataDownload);


    // dataJson = JSON.stringify(dataJson);
    Repo.getModello3(apiToken, dataJsonDownload)
      .then((response) => {
        var file = response.data.data.bytes;
        var a = window.document.createElement("a");
        a.href = "data:application/octet-stream;base64," + file;
        a.download = response.data.data.nomeFile + ".pdf";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
      .catch((error) => {
        console.log(error);
      });
  };



  const handleSubmit = () => {
    var dataJson = data;

    dataJson = JSON.stringify(dataJson);
    Repo.postUrlPagoPa(apiToken, dataJson)

      .then((response) => {
        window.location.href = response.data.data.url;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <div className="px-lg-5 px-2">
        <div className="row">
          <div className="col-12 col-lg-12">
            <div className="card-wrapper card-space">
              <div className="card card-bg">
                <div className="card-body">
                  <div className="row">
                    <div className="col-8">
                      {" "}
                      <h5 className="card-title">
                        {pagamento.nomeUnivocoCartella


                          ? pagamento.nomeUnivocoCartella
                          : pagamento.idRata}
                      </h5>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12">
                      <hr />
                    </div>
                  </div>
                  <div className="row">

                    <div className="col-xs-6 col-md-4">
                      <p>Importo Iniziale:

                        <b> {pagamento.importoIniziale



                          ? pagamento.importoIniziale
                          : 0} €</b>
                      </p>
                    </div>
                    <div className="col-xs-6 col-md-4">
                      <p>
                        Già Versato: <b>{pagamento.importoGiaVersato




                          ? pagamento.importoGiaVersato
                          : 0} €</b>
                      </p>
                    </div>
                  </div>
                  <div className="row">
                    {pagamento.idRata && (
                      <div className="col-xs-6 col-md-4">
                        <p>Importo Interessi:
                          <b>{pagamento.importoInteressi} € </b>

                        </p>
                      </div>
                    )}
                    <div className="col-xs-6 col-md-4">
                      <p>Causale:
                        <b>{pagamento.causale} </b>
                      </p>
                    </div>
                    <div className="col-xs-6 col-md-4">
                      <p>Scadenza
                        <b>{" "}
                          {pagamento.dataScadenza
                            ? moment(new Date(pagamento.dataScadenza)).format(
                              "DD-MM-YYYY"
                            )
                            : "/"}</b>
                      </p>
                    </div>
                    <div className="col-6">

                      <h5>Da Pagare: <b>{parseFloat(pagamento.importoDovuto) - parseFloat(0)} € </b></h5>

                    </div>
                  </div>

                  <hr></hr>

                  <div className="row">
                    {(!props.dettaglioCartella &&
                      pagamento.rate &&
                      pagamento.rate.length) > 0 ? (

                      <>
                        <ListaRate idPagamento={pagamento.idPagamento} setRataDettaglio={props.setRataDettaglio}>
                          {pagamento.rate}
                        </ListaRate>
                      </>
                    ) : (
                      <>
                        <div className="col-md-6 text-center mt-2">
                          <button
                            style={{
                              width: "240px",
                              height: "48px",
                            }}
                            type="button"
                            className="btn btn-primary"
                            onClick={downloadFile}
                          >
                            <svg className="icon icon-sm icon-white">
                              <use href={`${iconSprite}#it-download`} />
                            </svg>{" "}
                            <span>Scarica avviso cartaceo</span>
                          </button>
                        </div>
                        <div className="col-md-6 text-center mt-2 ">
                          <PagoPAButton
                            handleSubmit={handleSubmit}
                          ></PagoPAButton>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DettaglioPagamentiAttesi;
